// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".smartbanner {\n  padding-top: 12px;\n}\n", "",{"version":3,"sources":["smartbanner.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;AACnB","file":"smartbanner.css","sourcesContent":[".smartbanner {\n  padding-top: 12px;\n}\n"]}]);
// Exports
module.exports = exports;
